export default __webpack_public_path__ + "dde591a120bcb92884c70df41dc174e8.png";